import Doctor1 from 'assets/images/HelpPage/doctor1.png'
import Doctor2 from 'assets/images/HelpPage/doctor2.png'
import Doctor3 from 'assets/images/HelpPage/doctor3.png'
import Doctor4 from 'assets/images/HelpPage/doctor4.png'
import Doctor5 from 'assets/images/HelpPage/doctor5.png'

const doctorArray = [Doctor1, Doctor2, Doctor3, Doctor4, Doctor5]

export default doctorArray
